import { render, staticRenderFns } from "./layout-popup.vue?vue&type=template&id=d1449744&scoped=true&"
import script from "./layout-popup.vue?vue&type=script&lang=js&"
export * from "./layout-popup.vue?vue&type=script&lang=js&"
import style0 from "./layout-popup.vue?vue&type=style&index=0&id=d1449744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1449744",
  null
  
)

export default component.exports